// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   IconButton,
//   Typography,
// } from "@mui/material";
// import { IoClose } from "react-icons/io5";
// import format from "date-fns/format";
// export const DetailsDialog = ({ open, onClose, data }) => {
//   const isArrayOfChanges = Array.isArray(data?.details);
//   return (
//     <Dialog
//       open={open}
//       onClose={onClose}
//       fullWidth
//       maxWidth="sm"
//       scroll="paper"
//     >
//       <DialogTitle>
//         Log Details
//         <IconButton
//           aria-label="close"
//           onClick={onClose}
//           sx={{ position: "absolute", right: 8, top: 15 }}
//         >
//           <IoClose size={20} />
//         </IconButton>
//       </DialogTitle>

//       <DialogContent dividers style={{ maxHeight: "80vh", overflowY: "auto" }}>
//         <div className="d-flex justify-content-between">
//           <div className="d-flex flex-column">
//             <span className="text-dark fs-6 fw-medium">Date</span>
//             <span
//               className="text-darker fw-medium"
//               style={{ fontSize: "0.85rem" }}
//             >
//               {data?.created_at
//                 ? format(data?.created_at, "dd MMM yyy hh:mm a")
//                 : "-"}
//             </span>
//           </div>
//           <div className="d-flex flex-column">
//             <span className="text-dark fs-6 fw-medium">Performed By</span>
//             <span
//               className="text-darker fw-medium"
//               style={{ fontSize: "0.85rem" }}
//             >
//               {data?.performed_by?.name}
//             </span>
//           </div>
//           <div className="d-flex flex-column">
//             <span className="text-dark fs-6 fw-medium">Action</span>
//             <span
//               className="text-darker fw-medium"
//               style={{ fontSize: "0.85rem" }}
//             >
//               {data?.action}
//             </span>
//           </div>
//         </div>
//         <hr className="my-3" />
//         <div
//           className="text-bg-primary-soft mb-1 text-wrap p-1 rounded-1"
//           style={{ fontSize: "0.9rem" }}
//         >
//           {data?.message || "-"}
//         </div>
//         {isArrayOfChanges ? (
//           <div className="table-responsive">
//             <table className="table table-sm fs-6 mb-0 align-middle">
//               <thead className="table-light custom-thead">
//                 <tr>
//                   {Object.keys(data.details[0] || {}).map((key) => (
//                     <th key={key}>
//                       {key
//                         .replace(/_/g, " ")
//                         .replace(/^\w/, (c) => c.toUpperCase())}
//                     </th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {data.details.map((row, idx) => (
//                   <tr key={idx}>
//                     {Object.values(row).map((val, i) => (
//                       <td key={i}>{val}</td>
//                     ))}
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         ) : typeof data?.details === "string" ? (
//           <Typography className="p-3 text-sm text-gray-800">
//             {data.details}
//           </Typography>
//         ) : data?.details &&
//           typeof data?.details === "object" &&
//           data?.details?.exported_grn_numbers ? (
//           <>
//             <p className="fw-medium text-darker mb-0">Exported GRN</p>
//             {data.details.exported_grn_numbers.map((item, idx) => (
//               <span key={idx} className="small me-1">
//                 {item}
//                 {idx !== data.details.exported_grn_numbers.length - 1 && ","}
//               </span>
//             ))}
//           </>
//         ) : data?.details && typeof data?.details === "object" ? (
//           <div className="d-flex flex-column gap-1">
//             {Object.entries(data?.details)
//               .slice(1)
//               .map(([key, value]) => (
//                 <span key={key} className="text-darker fw-medium">
//                   <span
//                     className="text-dark fw-medium"
//                     style={{ fontSize: "0.9rem" }}
//                   >
//                     {key
//                       .replace(/_/g, " ")
//                       .replace(/^\w/, (c) => c.toUpperCase())}
//                     :
//                   </span>{" "}
//                   <span style={{ fontSize: "0.85rem" }}>{String(value)}</span>
//                 </span>
//               ))}
//           </div>
//         ) : (
//           <Typography className="p-3 text-sm text-gray-800">
//             No Details Available
//           </Typography>
//         )}
//       </DialogContent>
//     </Dialog>
//   );
// };
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
} from "@mui/material";
import { IoClose } from "react-icons/io5";
import format from "date-fns/format";

export const DetailsDialog = ({ open, onClose, data }) => {
  const isFieldChangeFormat = (array) =>
    Array.isArray(array) &&
    array.every(
      (item) =>
        typeof item === "object" &&
        "field" in item &&
        "before" in item &&
        "after" in item
    );

  const normalizeDetails = (details) => {
    const output = [];

    if (!details) return output;

    // Case 1: Array of changes (field-before-after)
    if (isFieldChangeFormat(details)) {
      return details.map((item) => ({
        field: item.field,
        before: item.before ?? "-",
        after: item.after ?? "-",
      }));
    }

    // Case 2: Array of static records
    if (Array.isArray(details)) {
      return details;
    }

    // Case 3: Object with 'changes'
    if ("changes" in details && typeof details.changes === "object") {
      for (const [field, value] of Object.entries(details.changes)) {
        output.push({
          field,
          before: value.before ?? "-",
          after: value.after ?? "-",
        });
      }
    }

    // Case 4: Object with 'before' and 'after'
    else if ("before" in details && "after" in details) {
      const keys = new Set([
        ...Object.keys(details.before || {}),
        ...Object.keys(details.after || {}),
      ]);
      for (const key of keys) {
        output.push({
          field: key,
          before: details.before?.[key] ?? "-",
          after: details.after?.[key] ?? "-",
        });
      }
    }

    return output;
  };

  const normalizedDetails = normalizeDetails(data?.details);
  const isNormalizedChanges =
    normalizedDetails.length > 0 &&
    normalizedDetails.every((item) => "field" in item && "before" in item && "after" in item);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" scroll="paper">
      <DialogTitle>
        Log Details
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 15 }}
        >
          <IoClose size={20} />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers style={{ maxHeight: "80vh", overflowY: "auto" }}>
        <div className="d-flex justify-content-between">
          <div className="d-flex flex-column">
            <span className="text-dark fs-6 fw-medium">Date</span>
            <span className="text-darker fw-medium" style={{ fontSize: "0.85rem" }}>
              {data?.created_at ? format(data?.created_at, "dd MMM yyy hh:mm a") : "-"}
            </span>
          </div>
          <div className="d-flex flex-column">
            <span className="text-dark fs-6 fw-medium">Performed By</span>
            <span className="text-darker fw-medium" style={{ fontSize: "0.85rem" }}>
              {data?.performed_by?.name}
            </span>
          </div>
          <div className="d-flex flex-column">
            <span className="text-dark fs-6 fw-medium">Action</span>
            <span className="text-darker fw-medium" style={{ fontSize: "0.85rem" }}>
              {data?.action.replace(/_/g, " ")}
            </span>
          </div>
        </div>

        <hr className="my-3" />

        <div className="text-bg-primary-soft mb-1 text-wrap p-1 rounded-1" style={{ fontSize: "0.9rem" }}>
          {data?.message || "-"}
        </div>

        {isNormalizedChanges ? (
          <div className="table-responsive">
            <table className="table table-sm fs-6 mb-0 align-middle">
              <thead className="table-light custom-thead">
                <tr>
                  <th>Property</th>
                  <th>Previous Value</th>
                  <th>Updated Value</th>
                </tr>
              </thead>
              <tbody>
                {normalizedDetails.map((row, idx) => (
                  <tr key={idx}>
                    <td>{row.field.replace(/_/g, " ").replace(/^\w/, (c) => c.toUpperCase())}</td>
                    <td>{String(row.before)}</td>
                    <td>{String(row.after)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : Array.isArray(data?.details) ? (
          <div className="table-responsive">
            <table className="table table-sm fs-6 mb-0 align-middle">
              <thead className="table-light custom-thead">
                <tr>
                  {Object.keys(data.details[0] || {}).map((key) => (
                    <th key={key}>{key.replace(/_/g, " ").replace(/^\w/, (c) => c.toUpperCase())}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data.details.map((row, idx) => (
                  <tr key={idx}>
                    {Object.values(row).map((val, i) => (
                      <td key={i}>{String(val)}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : typeof data?.details === "string" ? (
          <Typography className="p-3 text-sm text-gray-800">{data.details}</Typography>
        ) : data?.details && typeof data?.details === "object" && data?.details?.exported_grn_numbers ? (
          <>
            <p className="fw-medium text-darker mb-0">Exported GRN</p>
            {data.details.exported_grn_numbers.map((item, idx) => (
              <span key={idx} className="small me-1">
                {item}
                {idx !== data.details.exported_grn_numbers.length - 1 && ","}
              </span>
            ))}
          </>
        ) : data?.details && typeof data?.details === "object" ? (
          <div className="d-flex flex-column gap-1">
            {Object.entries(data.details)
             .filter(([key]) => !key.includes("_id"))
              .map(([key, value]) => (
                <span key={key} className="text-darker fw-medium">
                  <span className="text-dark fw-medium" style={{ fontSize: "0.9rem" }}>
                    {key.replace(/_/g, " ").replace(/^\w/, (c) => c.toUpperCase())}:
                  </span>{" "}
                  <span style={{ fontSize: "0.85rem" }}>{String(value)}</span>
                </span>
              ))}
          </div>
        ) : (
          <Typography className="p-3 text-sm text-gray-800">No Details Available</Typography>
        )}
      </DialogContent>
    </Dialog>
  );
};